import React, {useEffect, useState} from "react";
import {
    BUTTON,
    CREATION_ROLES,
    MODAL_CANCEL_TEXT,
    MODAL_CLOSE_TEXT,
    MODAL_SAVE_TEXT,
    ROLES,
} from "../../utils/constants";
import FocusTrap from "../../components/FocusTrap";
import {Modal, Table} from "react-bootstrap";
import classes from "./InstitutionManagementPage.module.css";
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import YuJaButton from "../../components/standardization/YuJaButton";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";
import {ReactComponent as CLOSE} from "../../images/Close.svg";
import {YuJaDropdown} from "../../components/standardization/YuJaDropdown";
import {InstitutionApiCalls} from "../../apis/InstitutionApiCalls";
import {Button} from "@base-ui/react/button";

export default function CSMAccessModal({setModalShow, show, user, grantedInstArr, notGrantedInstArr, reload}) {
    const {batchUpdateAdminManagers} = InstitutionApiCalls();
    const [isSaving, setIsSaving] = useState(false);
    const [tempGrantedInstArr, setTempGrantedInstArr] = useState([]);
    const [tempNotGrantedInstArr, setTempNotGrantedInstArr] = useState([]);
    const [filteredGrantedInstArr, setFilteredGrantedInstArr] = useState([]);
    const [filteredNotGrantedInstArr, setFilteredNotGrantedInstArr] = useState([]);
    const [keyword, setKeyword] = useState("");
    const [roleOptions, ] = useState([
        {value: ROLES.IT_MANAGER.value, label: ROLES.IT_MANAGER.display},
        {value: ROLES.CREATOR.value, label: ROLES.CREATOR.display},
        {value: ROLES.VIEWER.value, label: ROLES.VIEWER.display},
    ])



    const handleClose = () =>{
        setModalShow(false);
    };

    const handleSave = () => {


        // const newlyGranted = tempGrantedInstArr.filter(tempItem =>
        //     !grantedInstArr.some(origItem => origItem.institutionId === tempItem.institutionId)
        // );

        const newlyGranted = tempGrantedInstArr.filter(tempItem => {
            // Find the matching item in the original array
            const originalItem = grantedInstArr.find(
                orig => orig.institutionId === tempItem.institutionId
            );

            // Scenario A: It's a brand new assignment
            if (!originalItem) return true;

            // Scenario B: It existed, but a property (like accessLevel) changed
            // You can add more properties to the check if needed (e.g., tempItem.role !== originalItem.role)
            let tempAdminManagers = tempItem.adminManagers ? JSON.parse(tempItem.adminManagers) : [];
            let originalAdminManagers = originalItem.adminManagers ? JSON.parse(originalItem.adminManagers) : [];
            let tempManager = tempAdminManagers.find(m => m.id === user.userId);
            let originalManager = originalAdminManagers.find(m => m.id === user.userId);
            return !!tempManager && !!originalManager && tempManager.role !== originalManager.role;
        });

        const canceledAccess = grantedInstArr.filter(origItem =>
            !tempGrantedInstArr.some(tempItem => tempItem.institutionId === origItem.institutionId)
        );

        let canceledInstIdArr = canceledAccess.map(i => i.institutionId);
        let newGrantedInstArr = newlyGranted.map(i => {
            let tempAdminManagers = i.adminManagers ? JSON.parse(i.adminManagers) : [];
            let manager = tempAdminManagers.find(m => m.id === user.userId);
            return {
                instId: i.institutionId,
                role: manager.role
            };
        });

        setIsSaving(true);
        batchUpdateAdminManagers(user.userId, newGrantedInstArr, canceledInstIdArr)
            .then((success) => {
                if (success) {
                    reload();
                    setModalShow(false);
                }
            }).finally(() => setIsSaving(false));
    };

    const isSaveBtnDisabled = () => {
        if (JSON.stringify(tempGrantedInstArr) === JSON.stringify(grantedInstArr)
            && JSON.stringify(tempNotGrantedInstArr) === JSON.stringify(notGrantedInstArr)
        ) {
            return true;
        } else {
            return isSaving;
        }

    }


    useEffect(() => {
        if (show) {
            setTempGrantedInstArr(JSON.parse(JSON.stringify(grantedInstArr)));
            setTempNotGrantedInstArr(JSON.parse(JSON.stringify(notGrantedInstArr)));
        } else {
            setTempNotGrantedInstArr([]);
            setTempGrantedInstArr([]);
            setKeyword("");
        }

    }, [show]);

    useEffect(() => {
        if (!keyword || keyword.trim() === "") {
            setFilteredGrantedInstArr(tempGrantedInstArr);
            setFilteredNotGrantedInstArr(tempNotGrantedInstArr);
        } else {
            setFilteredGrantedInstArr(tempGrantedInstArr.filter(inst => {
                if (!!inst.fullName && inst.fullName.toLowerCase().includes(keyword.trim().toLowerCase())) {
                    return true;
                }

                if (!!inst.domain && inst.domain.toLowerCase().includes(keyword.trim().toLowerCase())) {
                    return true;
                }
                return false;
            }));
            setFilteredNotGrantedInstArr(tempNotGrantedInstArr.filter(inst => {
                if (!!inst.fullName && inst.fullName.toLowerCase().includes(keyword.trim().toLowerCase())) {
                    return true;
                }

                if (!!inst.domain && inst.domain.toLowerCase().includes(keyword.trim().toLowerCase())) {
                    return true;
                }
                return false;
            }));
        }

    }, [keyword, tempGrantedInstArr, tempNotGrantedInstArr]);

    const onAddInst = (instId) => {
        let copyGranted = JSON.parse(JSON.stringify(tempGrantedInstArr));
        let copyNotGranted = JSON.parse(JSON.stringify(tempNotGrantedInstArr));

        let inst = copyNotGranted.find(i => i.institutionId === instId);
        if (!inst) {
            return;
        }
        const managers = !!inst.adminManagers ? JSON.parse(inst.adminManagers) : [];
        let manager = managers.find(m => m.id === user.userId);
        if (!manager) {
            manager = {id: user.userId, role: CREATION_ROLES.IT_MANAGER.value};
            managers.push(manager);
        } else {
            manager.role = CREATION_ROLES.IT_MANAGER.value;
            delete manager.reason;
            delete manager.accessStartDate;
            delete manager.accessEndDate;
        }

        inst.adminManagers = JSON.stringify(managers);
        copyGranted.unshift(inst);


        copyNotGranted = copyNotGranted.filter(i => i.institutionId !== inst.institutionId);

        setTempGrantedInstArr(copyGranted);
        setTempNotGrantedInstArr(copyNotGranted);

    }

    const onRemoveInst = (instId) => {
        let copyGranted = JSON.parse(JSON.stringify(tempGrantedInstArr));
        let copyNotGranted = JSON.parse(JSON.stringify(tempNotGrantedInstArr));

        let inst = copyGranted.find(i => i.institutionId === instId);
        if (!inst) {
            return;
        }
        let managers = !!inst.adminManagers ? JSON.parse(inst.adminManagers) : [];
        managers = managers.filter(m => m.id !== user.userId);
        inst.adminManagers = JSON.stringify(managers);

        copyNotGranted.unshift(inst);
        copyGranted = copyGranted.filter(i => i.institutionId !== inst.institutionId);
        setTempGrantedInstArr(copyGranted);
        setTempNotGrantedInstArr(copyNotGranted);
    }

    return (
        <FocusTrap isOpened={show} setIsOpened={setModalShow}>
            <Modal
                id="CSM-institution-access-modal"
                show={show}
                aria-labelledby="CSM-institution-access-modal-title"
                backdrop={true}
                dialogClassName= {"csm-institution-access-modal"}
            >

                <ModalClose
                    tabIndex={0}
                    role={BUTTON}
                    aria-label={MODAL_CLOSE_TEXT}
                    onClick={handleClose}
                    className="modal-close"
                    style={{width: "24px", height: "24px"}}
                />
                <Modal.Header
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Modal.Title as="h2" className="modal-title" id="CSM-institution-access-modal-title">
                        { "Manage Institution Access"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className={classes.parentContainer} style={{background: "#FFF"}}>
                    <div className={classes.filterCard}>
                        <YuJaTextBox
                            containerStyle={{
                                flex: 1,
                                height: 35,
                                minWidth: 200,
                                maxWidth: 1000,
                                fontSize: 14,
                                lineHeight: 1.6,
                            }}
                            onChange={e => setKeyword(e.target.value)}
                            value={keyword}
                            before={<SearchIcon style={{marginRight: 5, width: 16}}/>}
                            after={
                                !!keyword
                                    ? (
                                        <Button
                                            aria-label={"Clear search keyword"}
                                            className={classes.closeIcon}
                                            onClick={() => setKeyword("")}
                                        >
                                            <CLOSE style={{width: 16, height: 16}}/>
                                        </Button>
                                    )
                                    : (<></>)
                            }
                            placeholder={"Search by Institution Name or Domain"}
                        />
                    </div>

                    <div className={classes.row} style={{flex: 1, minHeight: 0, width: "100%", gap: 30}}>
                        <div className={classes.column} style={{flex: 3, minWidth: 0, height: "100%", gap: 20}}>
                            <span className={classes.institutionAccessLabel}>All Institutions</span>
                            <div className={classes.column} style={{flex: 1, width: "100%", minHeight: 0}}>
                                <div className={classes.tableWrapper}>
                                    <Table hover>
                                        <thead>
                                            <tr>
                                                <th style={{paddingLeft: 20, width: 150}}>Institution Name</th>
                                                <th style={{width: 200}}>Domain</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredNotGrantedInstArr.map((inst, index) => (
                                                <tr key={index} style={{cursor: "pointer"}} onClick={() => onAddInst(inst.institutionId)}>
                                                    <td style={{paddingLeft: 20}}>
                                                        <span
                                                            style={{
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                display: "inline-block",
                                                                width: "100%",
                                                            }}
                                                            title={inst.fullName}
                                                        >
                                                            {inst.fullName}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span
                                                            style={{
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                display: "inline-block",
                                                                width: "100%",
                                                            }}
                                                            title={inst.domain}
                                                        >
                                                            {inst.domain}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                        <div className={classes.column} style={{flex: 4, minWidth: 0, height: "100%", gap: 20}}>
                            <span className={classes.institutionAccessLabel}>Institutions Managed</span>
                            <div className={classes.column} style={{flex: 1, width: "100%", minHeight: 0}}>
                                <div className={classes.tableWrapper}>
                                    <Table hover>
                                        <thead>
                                            <tr>
                                                <th style={{paddingLeft: 20, width: 150}}>Institution Name</th>
                                                <th style={{width: 200}}>Domain</th>
                                                <th style={{textAlign: "center", width: 180}}>Access Level</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredGrantedInstArr.map((inst, index) => {
                                                const managers = !!inst.adminManagers ? JSON.parse(inst.adminManagers) : [];
                                                let manager = managers.find(m => m.id === user.userId);

                                                return (
                                                    <tr key={index} style={{cursor: "pointer"}} onClick={() => onRemoveInst(inst.institutionId)}>
                                                        <td style={{paddingLeft: 20}}>
                                                            <span
                                                                style={{
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    display: "inline-block",
                                                                    width: "100%",
                                                                }}
                                                                title={inst.fullName}
                                                            >
                                                                {inst.fullName}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span
                                                                style={{
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    display: "inline-block",
                                                                    width: "100%",
                                                                }}
                                                                title={inst.domain}
                                                            >
                                                                {inst.domain}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <div
                                                                onClick={e => e.stopPropagation()}
                                                                className={classes.row}
                                                                style={{justifyContent: "center"}}
                                                            >
                                                                <YuJaDropdown
                                                                    data={roleOptions}
                                                                    value={manager.role}
                                                                    containerStyle={{width: 160}}
                                                                    style={{height: 35, width: 160}}
                                                                    onChange={(option) => {
                                                                        const copy = JSON.parse(JSON.stringify(tempGrantedInstArr));
                                                                        let institution = copy.find(i => i.institutionId === inst.institutionId);
                                                                        const managers = !!institution.adminManagers ? JSON.parse(institution.adminManagers) : [];
                                                                        const manager = managers.find(m => m.id === user.userId);
                                                                        manager.role = option.value;
                                                                        institution.adminManagers = JSON.stringify(managers);
                                                                        setTempGrantedInstArr(copy);
                                                                    }}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <div style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        gap: 10
                    }}>
                        <span style={{
                            display: "flex",
                            width: "100%",
                            alignItems: "center", justifyContent: "flex-end", gap: 10
                        }}>
                            <YuJaButton
                                onClick={handleClose}
                                type={"secondary"}
                                style={{
                                    width: 80,
                                    height: 36,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                               {MODAL_CANCEL_TEXT}
                            </YuJaButton>

                            <YuJaButton
                                onClick={handleSave}
                                disabled={isSaveBtnDisabled()}
                                style={{
                                    width: 80,
                                    height: 36,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    whiteSpace: "nowrap"
                                }}
                            >
                               {MODAL_SAVE_TEXT}
                            </YuJaButton>
                        </span>
                    </div>
                </Modal.Footer>

            </Modal>
        </FocusTrap>
);
}